import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";

const DAYS = ["Mon","Tue","Wed","Thu","Fri","Sat"];
const HOURS = ["07:00","09:00","11:00","13:00","15:00","17:00","19:00"];

export default function TimetablePage() {
  const [items, setItems] = useState([]);
  useEffect(()=>{ api.get("/timetable").then(({data})=>setItems(data)); },[]);

  const cell = (day, hour) => items.find(t => t.day===day && t.start_time===hour);

  return (
    <div>
      <PageHeader title="Timetable" subtitle="Weekly schedule at a glance" />
      <div className="linkedin-card p-3 overflow-x-auto" data-testid="timetable-grid">
        <div className="min-w-[900px]">
          <div className="grid grid-cols-8 gap-1 mb-1">
            <div className="text-[11px] font-semibold text-[#00000099] uppercase tracking-wider p-2">Day \ Time</div>
            {HOURS.map(h => <div key={h} className="text-[11px] font-semibold text-[#00000099] uppercase tracking-wider p-2 text-center">{h}</div>)}
          </div>
          {DAYS.map(day => (
            <div key={day} className="grid grid-cols-8 gap-1 mb-1">
              <div className="p-2 bg-[#F4F2EE] rounded font-semibold text-sm">{day}</div>
              {HOURS.map(h => {
                const c = cell(day, h);
                return (
                  <div key={h} className={`p-2 rounded text-xs ${c ? 'bg-[#EAF3FB] border border-[#0A66C2]/30' : 'bg-white border border-[#E0DFDC]'}`} data-testid={`tt-${day}-${h}`}>
                    {c ? (
                      <>
                        <div className="font-semibold text-[#0A66C2]">{c.subject}</div>
                        <div className="text-[10px] text-[#00000099] truncate">{c.faculty}</div>
                        <div className="text-[10px] text-[#00000099]">{c.room}</div>
                      </>
                    ) : <span className="text-[#00000055]">—</span>}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
